import Swiper from "swiper";
import {Pagination, Navigation, A11y} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/a11y";

const cardSlider = document.querySelectorAll('.cards-items-slider');

for( var i=0; i< cardSlider.length; i++ ) {
    cardSlider[i].classList.add('cards-items-slider-container-' + i);
    
    const swiper = new Swiper('.cards-items-slider-container-' + i + ' .cards-items', {
        modules: [Navigation, A11y, Pagination],
        a11y: {
            enabled: true,
        },
        freeMode: true,
        watchOverflow: true,
        preventClicks: true,
        preventClicksPropagation: true,
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
            nextEl: '.cards-items-slider-container-' + i + ' .swiper-next',
            prevEl: '.cards-items-slider-container-' + i + ' .swiper-prev',
        },
        pagination: {
            el: '.cards-items-slider-container-' + i + ' .swiper-pagination',
            type: "progressbar",
          },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 16,
                centeredSlides: false,
                loop: true
            },
            565: {
                slidesPerView: 2.2,
                spaceBetween: 16,
                centeredSlides: false,
                loop: false
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 18,
                centeredSlides: false,
                loop: false
            },            
        },
    });
};

const contentSlider = document.querySelectorAll('.content-slider-items-slider');

for( var i=0; i< contentSlider.length; i++ ) {
    contentSlider[i].classList.add('content-slider-items-slider-container-' + i);
    
    const swiper = new Swiper('.content-slider-items-slider-container-' + i + ' .content-slider-items', {
        modules: [Navigation, A11y, Pagination],
        a11y: {
            enabled: true,
        },
        freeMode: true,
        watchOverflow: true,
        preventClicks: true,
        preventClicksPropagation: true,
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
            nextEl: '.content-slider-items-slider-container-' + i + ' .swiper-next',
            prevEl: '.content-slider-items-slider-container-' + i + ' .swiper-prev',
        },
        pagination: {
            el: '.content-slider-items-slider-container-' + i + ' .swiper-pagination',
            type: "progressbar",
          },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 16,
                centeredSlides: false,
                loop: false
            },
            565: {
                slidesPerView: 2.2,
                spaceBetween: 16,
                centeredSlides: false,
                loop: false
            },
            768: {
                slidesPerView: 3.2,
                spaceBetween: 16,
                centeredSlides: false,
                loop: false
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 16,
                centeredSlides: false,
                loop: false
            },            
        },
    });
};

const imageSlider = document.querySelectorAll('.image-slider-items-slider');

for( var i=0; i< imageSlider.length; i++ ) {
    imageSlider[i].classList.add('image-slider-items-slider-container-' + i);
    imageSlider[i].closest(".image-slider-items-slider-wrap").classList.add('image-slider-items-slider-wrap-' + i);
    
    const swiper = new Swiper('.image-slider-items-slider-container-' + i + ' .image-slider-items', {
        modules: [Navigation, A11y, Pagination],
        a11y: {
            enabled: true,
        },
        freeMode: true,
        watchOverflow: true,
        preventClicks: true,
        preventClicksPropagation: true,
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        navigation: {
            nextEl: '.image-slider-items-slider-wrap-' + i + ' .swiper-next',
            prevEl: '.image-slider-items-slider-wrap-' + i + ' .swiper-prev',
        },
        pagination: {
            el: '.image-slider-items-slider-container-' + i + ' .swiper-pagination',
            type: "progressbar",
          },
    });
};


const benefitsSlider = document.querySelectorAll('.benefits-slider-items-slider');

for( var i=0; i< benefitsSlider.length; i++ ) {
    benefitsSlider[i].classList.add('benefits-slider-items-slider-container-' + i);
    
    const swiper = new Swiper('.benefits-slider-items-slider-container-' + i + ' .benefits-slider-items', {
        modules: [Navigation, A11y, Pagination],
        a11y: {
            enabled: true,
        },
        freeMode: true,
        watchOverflow: true,
        preventClicks: true,
        preventClicksPropagation: true,
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
            nextEl: '.benefits-slider-items-slider-container-' + i + ' .swiper-next',
            prevEl: '.benefits-slider-items-slider-container-' + i + ' .swiper-prev',
        },
        pagination: {
            el: '.benefits-slider-items-slider-container-' + i + ' .swiper-pagination',
            type: "progressbar",
          },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 16,
                centeredSlides: false,
                loop: true
            },
            565: {
                slidesPerView: 2.2,
                spaceBetween: 16,
                centeredSlides: false,
                loop: true
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 16,
                centeredSlides: false,
                loop: false
            },
            992: {
                slidesPerView: 6,
                spaceBetween: 16,
                centeredSlides: false,
                loop: false
            },            
        },
    });
};

const mediaSlider = document.querySelectorAll('.media-slider-items-slider');

for( var i=0; i< mediaSlider.length; i++ ) {
    mediaSlider[i].classList.add('media-slider-items-slider-container-' + i);
    
    const swiper = new Swiper('.media-slider-items-slider-container-' + i + ' .media-slider-items', {
        modules: [Navigation, A11y, Pagination],
        a11y: {
            enabled: true,
        },
        freeMode: true,
        watchOverflow: true,
        preventClicks: true,
        preventClicksPropagation: true,
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        navigation: {
            nextEl: '.media-slider-items-slider-container-' + i + ' .swiper-next',
            prevEl: '.media-slider-items-slider-container-' + i + ' .swiper-prev',
        },
        pagination: {
            el: '.media-slider-items-slider-container-' + i + ' .swiper-pagination',
            type: "bullets",
          },
    });
};
